export default [
  {
    path: '/',
    meta: {},
    component: () =>
      import(/* webpackChunkName: "adm" */ '../views/layouts/admin'),
    children: [
      {
        path: '/',
        name: 'landing',
        component: () =>
          import(/* webpackChunkName: "landing" */ '../views/layouts/landing'),
        meta: {},
      },
      {
        path: 'adm',
        name: 'admin',
        meta: {},
        redirect: '/adm/login',
        component: () =>
          import(/* webpackChunkName: "adm" */ '../views/layouts/admin'),
        children: [
          {
            path: 'opr',
            name: 'operational',
            meta: {},
            redirect: '/adm/opr/dashboard',
            component: () =>
              import(/* webpackChunkName: "opr" */ '../views/operational'),
            children: [
              {
                path: 'dashboard',
                name: 'operationalDashboard',
                meta: {
                  modulName: 'operasional',
                  pageName: 'dashboard',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "opr-dashboard" */ '../views/operational/dashboard'
                  ),
              },
              {
                path: 'info/:type?',
                name: 'contInfo',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "opr-cont-info" */ '../views/operational/container-info'
                  ),
              },
              {
                path: 'form-principle/:id?',
                name: 'formPrinciples',
                meta: {
                  modulName: 'operasional',
                  pageName: 'principle',
                  pageType: 'create_update',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "opr-form-principles" */ '../views/operational/principles/form-modal'
                  ),
              },
              {
                path: 'principles',
                name: 'principles',
                meta: {
                  modulName: 'operasional',
                  pageName: 'principle',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "opr-principles" */ '../views/operational/principles'
                  ),
              },
              {
                path: 'form-customer/:id?',
                name: 'formCustomer',
                meta: {
                  modulName: 'operasional',
                  pageName: 'customer',
                  pageType: 'create_update',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "opr-form-customers" */ '../views/operational/customers/form-modal'
                  ),
              },
              {
                path: 'customers',
                name: 'customers',
                meta: {
                  modulName: 'operasional',
                  pageName: 'customer',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "opr-customers" */ '../views/operational/customers'
                  ),
              },
              {
                path: 'customers/:id_customer?/cabang',
                name: 'customersCabang',
                meta: {
                  modulName: 'operasional',
                  pageName: 'customer',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "opr-customers-cabang" */ '../views/operational/customers/cabang'
                  ),
              },
              {
                path: 'doc/interchange/form-interchange/:id?',
                name: 'formInterchange',
                meta: {
                  modulName: 'operasional',
                  pageName: 'docInterchange',
                  pageType: 'create_update',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "opr-form-interchange" */ '../views/operational/document/interchange/form-interchange'
                  ),
              },
              {
                path: 'doc/interchange',
                name: 'interchange',
                meta: {
                  modulName: 'operasional',
                  pageName: 'docInterchange',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "opr-interchange" */ '../views/operational/document/interchange'
                  ),
              },
              {
                path: 'doc/booking/form-booking/:id?',
                name: 'formBooking',
                meta: {
                  modulName: 'operasional',
                  pageName: 'docBooking',
                  pageType: 'create_update',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "opr-form-booking" */ '../views/operational/document/booking/form-booking'
                  ),
              },
              {
                path: 'doc/booking',
                name: 'booking',
                meta: {
                  modulName: 'operasional',
                  pageName: 'docBooking',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "opr-booking" */ '../views/operational/document/booking'
                  ),
              },
              {
                path: 'doc/checking',
                name: 'checking',
                meta: {
                  modulName: 'operasional',
                  pageName: 'docChecking',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "opr-checking" */ '../views/operational/document/checking'
                  ),
              },
              {
                path: 'check/in',
                name: 'dataCheckIn',
                meta: {
                  modulName: 'operasional',
                  pageName: 'dataCheckIn',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "opr-check-in" */ '../views/operational/check/data-in'
                  ),
              },
              {
                path: 'check/out',
                name: 'dataCheckOut',
                meta: {
                  modulName: 'operasional',
                  pageName: 'dataCheckOut',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "opr-check-out" */ '../views/operational/check/data-out'
                  ),
              },
              {
                path: 'payment',
                name: 'payment',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "opr-payment" */ '../views/operational/payment'
                  ),
                redirect: '/adm/opr/payment/interchange',
                children: [
                  {
                    path: 'interchange',
                    name: 'paymentInterchange',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'paymentInterchange',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-payment-interchange" */ '../views/operational/payment/interchange'
                      ),
                  },
                  {
                    path: 'form-payment-interchange/:id?',
                    name: 'paymentFormInterchange',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'paymentInterchange',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-payment-form-interchange" */ '../views/operational/payment/interchange/form-interchange'
                      ),
                  },
                  {
                    path: 'print-kwitansi-interchange/:id?/:type?',
                    name: 'paymentInterchangeKwitansi',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'paymentInterchange',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-payment-interchange-kwitansi" */ '../views/operational/payment/interchange/print-report/kwitansi.vue'
                      ),
                  },
                  {
                    path: 'booking',
                    name: 'paymentBooking',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'paymentBooking',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-payment-booking" */ '../views/operational/payment/booking'
                      ),
                  },
                  {
                    path: 'form-payment-booking/:id?',
                    name: 'paymentFormBooking',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'paymentBooking',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-payment-form-booking" */ '../views/operational/payment/booking/form-booking'
                      ),
                  },
                  {
                    path: 'print-kwitansi-booking/:id?/:type?',
                    name: 'paymentBookingKwitansi',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'paymentBooking',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-payment-booking-kwitansi" */ '../views/operational/payment/booking/print-report/kwitansi.vue'
                      ),
                  },
                  {
                    path: 'repair',
                    name: 'paymentRepair',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'paymentRepair',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-payment-repair" */ '../views/operational/payment/repair'
                      ),
                  },
                  {
                    path: 'form-payment-repair/:id?',
                    name: 'paymentFormRepair',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'paymentRepair',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-payment-form-repair" */ '../views/operational/payment/repair/form-repair'
                      ),
                  },
                  {
                    path: 'print-kwitansi-repair/:id?/:type?',
                    name: 'paymentRepairKwitansi',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'paymentRepair',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-payment-repair-kwitansi" */ '../views/operational/payment/repair/print-report/kwitansi.vue'
                      ),
                  },
                  {
                    path: 'seal',
                    name: 'paymentSeal',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'paymentSeal',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-payment-seal" */ '../views/operational/payment/seal'
                      ),
                  },
                  {
                    path: 'form-payment-seal/:id?',
                    name: 'paymentFormSeal',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'paymentSeal',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-payment-form-seal" */ '../views/operational/payment/seal/form-seal'
                      ),
                  },
                  {
                    path: 'print-kwitansi-seal/:id?/:type?',
                    name: 'paymentSealKwitansi',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'paymentSeal',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-payment-seal-kwitansi" */ '../views/operational/payment/seal/print-report/kwitansi.vue'
                      ),
                  },
                ],
              },
              {
                path: 'truck',
                name: 'truck',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "opr-truck" */ '../views/operational/truck'
                  ),
                redirect: '/adm/opr/truck/booking',
                children: [
                  {
                    path: 'vendor',
                    name: 'vendorTruck',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'TruckVendor',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-truck-vendor" */ '../views/operational/truck/vendor-truck'
                      ),
                  },
                  {
                    path: 'booking',
                    name: 'bookingTruck',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'TruckBooking',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-truck-booking" */ '../views/operational/truck/booking-truck'
                      ),
                  },
                  {
                    path: 'form-booking-truck/:id?',
                    name: 'formBookingTruck',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'TruckBooking',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-truck-form-booking" */ '../views/operational/truck/booking-truck/form-book-truck'
                      ),
                  },
                  {
                    path: 'print-booking-truck/:id?',
                    name: 'printBookingTruck',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'TruckBooking',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-truck-print-booking" */ '../views/operational/truck/booking-truck/print'
                      ),
                  },
                  {
                    path: 'interchange',
                    name: 'interchangeTruck',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'TruckInterchange',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-truck-interchange" */ '../views/operational/truck/interchange-truck'
                      ),
                  },
                  {
                    path: 'form-interchange-truck/:id?',
                    name: 'formInterchangeTruck',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'TruckInterchange',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-truck-form-interchange" */ '../views/operational/truck/interchange-truck/form-book-truck'
                      ),
                  },
                  {
                    path: 'print-interchange-truck/:id?',
                    name: 'printInterchangeTruck',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'TruckInterchange',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-truck-print-interchange" */ '../views/operational/truck/interchange-truck/print'
                      ),
                  },
                ],
              },
              {
                path: 'crani',
                name: 'crani',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "opr-crani" */ '../views/operational/crani'
                  ),
                redirect: '/adm/opr/crani/container-in',
                children: [
                  {
                    path: 'container-in/form/:id?',
                    name: 'formCraniContainerIn',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'craniIn',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-crani-in-form" */ '../views/operational/crani/container-in/form-container-in'
                      ),
                  },
                  {
                    path: 'container-in',
                    name: 'craniContainerIn',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'craniIn',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-crani-in" */ '../views/operational/crani/container-in'
                      ),
                  },
                  {
                    path: 'container-out/form/:id?',
                    name: 'formCraniContainerOut',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'craniOut',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-crani-out-form" */ '../views/operational/crani/container-out/form-container-out'
                      ),
                  },
                  {
                    path: 'container-out',
                    name: 'craniContainerOut',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'craniOut',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-crani-out" */ '../views/operational/crani/container-out'
                      ),
                  },
                ],
              },
              {
                path: 'eir',
                name: 'eir',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "opr-eir" */ '../views/operational/eir'
                  ),
                redirect: '/adm/opr/eir/container-in',
                children: [
                  {
                    path: 'print-eir-in/:id?',
                    name: 'eirPrintEirIn',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eirIn',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-print-eirin" */ '../views/operational/eir/container-in/print'
                      ),
                  },
                  {
                    path: 'container-in',
                    name: 'eirContainerIn',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eirIn',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-eir-in" */ '../views/operational/eir/container-in'
                      ),
                  },
                  {
                    path: 'print-eir-out/:id?',
                    name: 'printEirContainerOut',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eirOut',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-eir-out-printform" */ '../views/operational/eir/container-out/print'
                      ),
                  },
                  {
                    path: 'container-out/form/:id?',
                    name: 'formEirContainerOut',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-eir-out-form" */ '../views/operational/eir/container-out/form-container-out'
                      ),
                  },
                  {
                    path: 'container-out',
                    name: 'eirContainerOut',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eirOut',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-eir-out" */ '../views/operational/eir/container-out'
                      ),
                  },
                  {
                    path: 'document-taken/form/:id?',
                    name: 'formDocumentTaken',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eirDocTaken',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-eir-doc-taken" */ '../views/operational/eir/document-taken/form-document'
                      ),
                  },
                  {
                    path: 'document-taken',
                    name: 'eirDocumentTaken',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eirDocTaken',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-eir-document" */ '../views/operational/eir/document-taken'
                      ),
                  },
                  {
                    path: 'print-document-taken/:typecetak?/:searchdata?',
                    name: 'eirDocumentTakenPrint',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eirDocTaken',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-eir-doc-taken-print" */ '../views/operational/eir/document-taken/print/print-eir-in'
                      ),
                  },
                ],
              },
              {
                path: 'pti',
                name: 'pti',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "opr-pti" */ '../views/operational/eir'
                  ),
                redirect: '/adm/opr/pti/survey',
                children: [
                  {
                    path: 'survey',
                    name: 'ptiSurveyList',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'ptiSurvey',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-pti-survey" */ '../views/operational/pti/survey'
                      ),
                  },
                  {
                    path: 'form-survey-pti/:id?',
                    name: 'ptiSurvey',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'ptiSurvey',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-form-pti-survey" */ '../views/operational/pti/survey/form-survey-pti'
                      ),
                  },
                  {
                    path: 'form-work-order/:id?',
                    name: 'ptiFormWorkOrder',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'ptiWorkOrder',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-pti-wo" */ '../views/operational/pti/work-order/form-workorder'
                      ),
                  },
                  {
                    path: 'print-work-order/:id?',
                    name: 'ptiPrintWorkOrder',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'ptiWorkOrder',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-pti-print-wo" */ '../views/operational/pti/work-order/print-workorderpti'
                      ),
                  },
                  {
                    path: 'work-order',
                    name: 'ptiWorkOrder',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'ptiWorkOrder',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-pti-wo" */ '../views/operational/pti/work-order'
                      ),
                  },
                  {
                    path: 'repair-container',
                    name: 'ptiRepairContainer',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'ptiRepairContainer',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-pti-repaircontainer" */ '../views/operational/pti/repair-container'
                      ),
                  },
                  {
                    path: 'print-list-work-order',
                    name: 'repairPrintListWoPti',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'ptiRepairContainer',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-repair-print-pti-wo" */ '../views/operational/pti/repair-container/tab-work-order/print-workorderpti'
                      ),
                  },
                  {
                    path: 'print-list-on-progress',
                    name: 'repairPrintListOnProgressPti',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'ptiRepairContainer',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-repair-print-pti-onprogress" */ '../views/operational/pti/repair-container/tab-onprogress/print-workorderpti'
                      ),
                  },
                  {
                    path: 'print-list-reject',
                    name: 'repairPrintListRejectPti',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'ptiRepairContainer',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-repair-print-pti-reject" */ '../views/operational/pti/repair-container/tab-reject-repair/print-workorderpti'
                      ),
                  },
                  {
                    path: 'print-list-complete',
                    name: 'repairPrintListCompletePti',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'ptiRepairContainer',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-repair-print-pti-complete" */ '../views/operational/pti/repair-container/tab-complete-repair/print-workorderpti'
                      ),
                  },
                  {
                    path: 'quality-control',
                    name: 'ptiQualityControl',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'ptiQualityControl',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-pti-quality-control" */ '../views/operational/pti/quality-control'
                      ),
                  },
                  {
                    path: 'form-quality-control/:id_wo_pti_detail?/:id?',
                    name: 'PtiFormQualityControl',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'ptiQualityControl',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-formptiquality-control" */ '../views/operational/pti/quality-control/form-quality-control'
                      ),
                  },
                  {
                    path: 'form-estimatepti-cost/:id?',
                    name: 'ptiFormEstimateCost',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'ptiEstimateCost',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-pti-form-estimate-cost" */ '../views/operational/pti/estimate-cost/form-estimate'
                      ),
                  },
                  {
                    path: 'estimate-cost',
                    name: 'ptiEstimateCost',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'ptiEstimateCost',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-pti-estimate" */ '../views/operational/pti/estimate-cost'
                      ),
                  },
                  {
                    path: 'print-pti/:id?',
                    name: 'ptiEstimateCostPrint',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'ptiEstimateCost',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-pti-estimate-print" */ '../views/operational/pti/estimate-cost/print-pti'
                      ),
                  },
                ],
              },
              {
                path: 'survey',
                name: 'survey',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "opr-survey" */ '../views/operational/survey'
                  ),
                redirect: '/adm/opr/survey/container-in',
                children: [
                  {
                    path: 'container-in',
                    name: 'containerSurveyIn',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'surveyIn',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-container-survey" */ '../views/operational/survey/container-survey-in'
                      ),
                  },
                  {
                    path: 'form-container-survey/:id?',
                    name: 'formContainerSurvey',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'surveyIn',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-form-container-survey" */ '../views/operational/survey/container-survey-in/form-survey'
                      ),
                  },
                  {
                    path: 'container-out',
                    name: 'containerSurveyOut',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'surveyOut',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-container-survey-out" */ '../views/operational/survey/container-survey-out'
                      ),
                  },
                  {
                    path: 'form-container-survey-out/:id?',
                    name: 'formContainerSurveyOut',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'surveyOut',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-form-container-survey-out" */ '../views/operational/survey/container-survey-out/form-survey'
                      ),
                  },
                  {
                    path: 'part-of-survey',
                    name: 'masterPartOfSurvey',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'surveyPartOfSurvey',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-part-survey" */ '../views/operational/survey/master'
                      ),
                  },
                  {
                    path: 'pending-survey',
                    name: 'pendingSurvey',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-pending-survey" */ '../views/operational/survey/pending-survey'
                      ),
                  },
                  {
                    path: 'nat-container',
                    name: 'natContainer',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-nat-survey" */ '../views/operational/survey/nat-container'
                      ),
                  },
                ],
              },
              {
                path: 'eor',
                name: 'eor',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "opr-eor" */ '../views/operational/eor'
                  ),
                redirect: '/adm/opr/eor/estimate-cost',
                children: [
                  {
                    path: 'vendor-repair',
                    name: 'VendorRepair',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eorVendorRepair',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-vendor-repair" */ '../views/operational/eor/vendor-repair'
                      ),
                  },
                  {
                    path: 'form-estimate-cost/:id?',
                    name: 'formDamageCost',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eorEstimateCost',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-form-estimate-cost" */ '../views/operational/eor/estimate-cost/form-estimate'
                      ),
                  },
                  {
                    path: 'estimate-cost',
                    name: 'DamageCost',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eorEstimateCost',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-estimate-cost" */ '../views/operational/eor/estimate-cost'
                      ),
                  },
                  {
                    path: 'print-eor/:id?',
                    name: 'printEor',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eorEstimateCost',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-print-estimate-cost" */ '../views/operational/eor/estimate-cost/print-eor'
                      ),
                  },
                  {
                    path: 'form-work-order/:id?',
                    name: 'formWorkOrder',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eorWorkOrder',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-form-work-order" */ '../views/operational/eor/work-order/form-workorder'
                      ),
                  },
                  {
                    path: 'print-work-order/:id?',
                    name: 'printWorkOrder',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eorWorkOrder',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-print-work-order" */ '../views/operational/eor/work-order/print-workorder'
                      ),
                  },
                  {
                    path: 'work-order',
                    name: 'workOrder',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eorWorkOrder',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-work-order" */ '../views/operational/eor/work-order'
                      ),
                  },
                  {
                    path: 'form-quality-control/:id_wo_detail?/:id?',
                    name: 'EorFormQualityControl',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eorQualityControl',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-formeorquality-control" */ '../views/operational/eor/quality-control/form-quality-control'
                      ),
                  },
                  {
                    path: 'repair-container',
                    name: 'repairContainer',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eorRepairContainer',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-repair-container" */ '../views/operational/eor/repair-container'
                      ),
                  },
                  {
                    path: 'print-repair-eor/:id?',
                    name: 'printRepairEor',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eorRepairContainer',
                      pageType: 'view',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-repair-container" */ '../views/operational/eor/repair-container/tab-complete-repair/print-eor'
                      ),
                  },
                  {
                    path: 'print-list-work-order',
                    name: 'repairPrintListWo',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eorRepairContainer',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-repair-print-wo" */ '../views/operational/eor/repair-container/tab-work-order/print-workorder'
                      ),
                  },
                  {
                    path: 'print-list-on-progress',
                    name: 'repairPrintListOnProgress',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eorRepairContainer',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-repair-print-onprogress" */ '../views/operational/eor/repair-container/tab-onprogress/print-workorder'
                      ),
                  },
                  {
                    path: 'print-list-reject',
                    name: 'repairPrintListReject',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eorRepairContainer',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-repair-print-reject" */ '../views/operational/eor/repair-container/tab-reject-repair/print-workorder'
                      ),
                  },
                  {
                    path: 'print-list-complete',
                    name: 'repairPrintListComplete',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eorRepairContainer',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-repair-print-complete" */ '../views/operational/eor/repair-container/tab-complete-repair/print-workorder'
                      ),
                  },
                  {
                    path: 'quality-control',
                    name: 'EorQualityControl',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'eorQualityControl',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-eorquality-control" */ '../views/operational/eor/quality-control'
                      ),
                  },
                  {
                    path: 'repeat-repair',
                    name: 'repeatRepair',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'repeatRepair',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-eor-repeat-repair" */ '../views/operational/eor/repeat-repair'
                      ),
                  },
                  {
                    path: 'form-repeat-repair/:id?',
                    name: 'formRepeatRepair',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'repeatRepair',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-form-repeat-repair" */ '../views/operational/eor/repeat-repair/form-repeat-repair'
                      ),
                  },
                ],
              },
              {
                path: 'container',
                name: 'container',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "opr-container" */ '../views/operational/container'
                  ),
                redirect: '/adm/opr/container/condition',
                children: [
                  {
                    path: 'back-to-stock',
                    name: 'backToStock',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'backToStock',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-back-to-stock" */ '../views/operational/back-to-stock'
                      ),
                  },
                  {
                    path: 'block-container',
                    name: 'blockContainerCondition',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'blockContainer',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-block-container" */ '../views/operational/container/block-container'
                      ),
                  },
                  {
                    path: 'block-document',
                    name: 'blockDocumentCondition',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'blockDocument',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-block-container" */ '../views/operational/container/block-document'
                      ),
                  },
                  {
                    path: 'condition',
                    name: 'contCondition',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'contCondition',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-cont-condition" */ '../views/operational/container/condition'
                      ),
                  },
                  {
                    path: 'information',
                    name: 'contInformation',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'contInformation',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-cont-information" */ '../views/operational/container/information'
                      ),
                  },
                  {
                    path: 'location',
                    name: 'contLocation',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'contLocation',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-cont-location" */ '../views/operational/container/location'
                      ),
                  },
                  {
                    path: 'photos',
                    name: 'contPhotos',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'contPhoto',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-cont-photos" */ '../views/operational/container/photos'
                      ),
                  },
                  {
                    path: 'cleaning',
                    name: 'contCleaning',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'contCleaning',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-cont-cleaning" */ '../views/operational/container/cleaning'
                      ),
                  },
                ],
              },
              {
                path: 'seal',
                name: 'seal',
                meta: {
                  modulName: 'operasional',
                  pageName: 'seal',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "opr-seal" */ '../views/operational/seal'
                  ),
              },
              {
                path: 'share-seal',
                name: 'shareSeal',
                meta: {
                  modulName: 'operasional',
                  pageName: 'shareSeal',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "opr-share-seal" */ '../views/operational/share-seal'
                  ),
              },
              {
                path: 'transaksi',
                name: 'transaksi',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "opr-transaksi" */ '../views/operational/transaksi'
                  ),
                redirect: '/adm/opr/transaksi/document-fee-in',
                children: [
                  {
                    path: 'other-in',
                    name: 'transOtherIn',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transOtherIn',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-other-in" */ '../views/operational/transaksi/other-in'
                      ),
                  },
                  {
                    path: 'print-trans-other-in',
                    name: 'transOtherInPrint',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transOtherIn',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-other-in" */ '../views/operational/transaksi/other-in/print-other-in'
                      ),
                  },
                  {
                    path: 'document-fee-in',
                    name: 'transDocumentFeeIn',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transDocumentFeeIn',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-document-fee" */ '../views/operational/transaksi/document-fee-in'
                      ),
                  },
                  {
                    path: 'print-trans-doc-in',
                    name: 'transDocumentFeeInPrint',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transDocumentFeeIn',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-document-fee" */ '../views/operational/transaksi/document-fee-in/print-doc-in'
                      ),
                  },
                  {
                    path: 'other-out',
                    name: 'transOtherOut',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transOtherOut',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-other-out" */ '../views/operational/transaksi/other-out'
                      ),
                  },
                  {
                    path: 'print-trans-other-out',
                    name: 'transOtherOutPrint',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transOtherOut',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-other-out" */ '../views/operational/transaksi/other-out/print-other-out'
                      ),
                  },
                  {
                    path: 'document-fee-out',
                    name: 'transDocumentFeeOut',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transDocumentFeeOut',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-document-fee-out" */ '../views/operational/transaksi/document-fee-out'
                      ),
                  },
                  {
                    path: 'print-trans-doc-out',
                    name: 'transDocumentFeeOutPrint',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transDocumentFeeOut',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-document-fee" */ '../views/operational/transaksi/document-fee-out/print-doc-out'
                      ),
                  },
                  {
                    path: 'storage',
                    name: 'transStorage',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transStorage',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-storage" */ '../views/operational/transaksi/storage'
                      ),
                  },
                  {
                    path: 'print-trans-storage',
                    name: 'transPrintStorage',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transStorage',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-storage" */ '../views/operational/transaksi/storage/print-storage'
                      ),
                  },
                  {
                    path: 'lift-off',
                    name: 'transLiftOff',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transLiftOff',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-lift-off" */ '../views/operational/transaksi/lift-off'
                      ),
                  },
                  {
                    path: 'print-trans-lift-off',
                    name: 'transPrintLiftOff',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transLiftOff',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-lift-off" */ '../views/operational/transaksi/lift-off/print-lift-off'
                      ),
                  },
                  {
                    path: 'lift-on',
                    name: 'transLiftOn',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transLiftOn',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-lift-on" */ '../views/operational/transaksi/lift-on'
                      ),
                  },
                  {
                    path: 'print-trans-lift-on',
                    name: 'transPrintLiftOn',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transLiftOn',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-lift-on" */ '../views/operational/transaksi/lift-on/print-lift-on'
                      ),
                  },
                  {
                    path: 'cleaning',
                    name: 'transCleaning',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transCleaning',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-cleaning" */ '../views/operational/transaksi/cleaning'
                      ),
                  },
                  {
                    path: 'print-trans-cleaning',
                    name: 'transPrintCleaning',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transCleaning',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-cleaning" */ '../views/operational/transaksi/cleaning/print-cleaning'
                      ),
                  },
                  {
                    path: 'truck-booking',
                    name: 'transTruckBooking',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transTruckBooking',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-truck-booking" */ '../views/operational/transaksi/truck-booking'
                      ),
                  },
                  {
                    path: 'print-trans-truck-booking',
                    name: 'transPrintTruckBooking',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transTruckBooking',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-truck-booking" */ '../views/operational/transaksi/truck-booking/print-truck-booking'
                      ),
                  },
                  {
                    path: 'truck-interchange',
                    name: 'transTruckInterchange',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transTruckInterchange',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-truck-interchange" */ '../views/operational/transaksi/truck-interchange'
                      ),
                  },
                  {
                    path: 'print-trans-truck-interchange',
                    name: 'transPrintTrucInterchange',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transTruckInterchange',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-truck-interchange" */ '../views/operational/transaksi/truck-interchange/print-truck-interchange'
                      ),
                  },
                  {
                    path: 'eor',
                    name: 'transEor',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transEor',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-eor" */ '../views/operational/transaksi/eor'
                      ),
                  },
                  {
                    path: 'print-trans-eor',
                    name: 'transPrintEOR',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transEor',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-eor" */ '../views/operational/transaksi/eor/print-eor'
                      ),
                  },
                  {
                    path: 'pti',
                    name: 'transPti',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transPti',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-pti" */ '../views/operational/transaksi/pti'
                      ),
                  },
                  {
                    path: 'print-trans-pti',
                    name: 'transPrintPti',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'transPti',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-trans-pti" */ '../views/operational/transaksi/pti/print-pti'
                      ),
                  },
                ],
              },
              {
                path: 'report',
                name: 'report',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "opr-report" */ '../views/operational/transaksi'
                  ),
                redirect: '/adm/opr/report/container-in',
                children: [
                  {
                    path: 'daily-check',
                    name: 'reportDailyCheck',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportDailyCheck',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-daily-check" */ '../views/operational/report/daily-report-check'
                      ),
                  },
                  {
                    path: 'daily',
                    name: 'reportDaily',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportDaily',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-daily" */ '../views/operational/report/daily-report'
                      ),
                  },
                  {
                    path: 'print-daily/:id_principle?/:date?',
                    name: 'reportPrintDaily',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportDaily',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-print-daily" */ '../views/operational/report/daily-report/print-report'
                      ),
                  },
                  {
                    path: 'edi-daily',
                    name: 'reportEDIDaily',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportEDIDaily',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-edi-report-daily" */ '../views/operational/report/edi-daily-report'
                      ),
                  },
                  {
                    path: 'print-edi-daily/:id_principle?/:date?',
                    name: 'reportPrintEDIDaily',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportEDIDaily',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-print-edi-daily" */ '../views/operational/report/edi-daily-report/print-report'
                      ),
                  },
                  {
                    path: 'monthly-cashier',
                    name: 'reportMonthlyCashier',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportMonthlyCashier',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-monthly-cashier" */ '../views/operational/report/monthly-cashier'
                      ),
                  },
                  {
                    path: 'print-monthly-cashier/:date?/:tipe_report?',
                    name: 'reportPrintMonthlyCashier',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportMonthlyCashier',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-print-monthly-cashier" */ '../views/operational/report/monthly-cashier/print-report'
                      ),
                  },
                  {
                    path: 'cashier',
                    name: 'reportCashier',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportCashier',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-cashier" */ '../views/operational/report/report-cashier'
                      ),
                  },
                  {
                    path:
                      'print-cashier/:id_user?/:start_date?/:end_date?/:seal_only?',
                    name: 'reportPrintCashier',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportCashier',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-print-cashier" */ '../views/operational/report/report-cashier/print-report'
                      ),
                  },
                  {
                    path: 'seal',
                    name: 'reportSeal',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportSeal',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-seal" */ '../views/operational/report/seal'
                      ),
                  },
                  {
                    path: 'print-seal/:id_principle?/:start_date?/:end_date?',
                    name: 'reportPrintSeal',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportSeal',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-print-seal" */ '../views/operational/report/seal/print-report'
                      ),
                  },
                  {
                    path: 'teus',
                    name: 'reportTeusContainer',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportTeusContainer',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-teus" */ '../views/operational/report/teus'
                      ),
                  },
                  {
                    path:
                      'print-teus/:tipe_report?/:id_principle?/:start_date?/:end_date?',
                    name: 'reportPrintTeusContainer',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportTeusContainer',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-print-teus" */ '../views/operational/report/teus/print-report'
                      ),
                  },
                  {
                    path: 'container-in',
                    name: 'reportContainerIn',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportContIn',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-containerin" */ '../views/operational/report/container-in'
                      ),
                  },
                  {
                    path: 'print-container-in',
                    name: 'reportPrintContainerIn',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportContIn',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-printcontainerin" */ '../views/operational/report/container-in/print-report'
                      ),
                  },
                  {
                    path: 'container-out',
                    name: 'reportContainerOut',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportContOut',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-containerout" */ '../views/operational/report/container-out'
                      ),
                  },
                  {
                    path: 'print-container-out',
                    name: 'reportPrintContainerOut',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportContOut',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-printcontainerout" */ '../views/operational/report/container-out/print-report'
                      ),
                  },
                  {
                    path: 'stok-container',
                    name: 'reportContainerStock',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportStockContainer',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-containerstock" */ '../views/operational/report/container-stock'
                      ),
                  },
                  {
                    path: 'print-container-stock',
                    name: 'reportPrintContainerStock',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportStockContainer',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-printcontainerstock" */ '../views/operational/report/container-stock/print-report'
                      ),
                  },
                  {
                    path: 'survey-in',
                    name: 'reportSurveyIn',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportSurveyIn',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-surveyin" */ '../views/operational/report/container-survey-in'
                      ),
                  },
                  {
                    path: 'print-survey-in',
                    name: 'reportPrintSurveyIn',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportSurveyIn',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-printsurveyin" */ '../views/operational/report/container-survey-in/print-report'
                      ),
                  },
                  {
                    path: 'survey-out',
                    name: 'reportSurveyOut',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportSurveyOut',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-surveyout" */ '../views/operational/report/container-survey-out'
                      ),
                  },
                  {
                    path: 'print-survey-out',
                    name: 'reportPrintSurveyOut',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportSurveyOut',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-printsurveyout" */ '../views/operational/report/container-survey-out/print-report'
                      ),
                  },
                  {
                    path: 'eor-container',
                    name: 'reportContainerEor',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportEorContainer',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-containersurvey" */ '../views/operational/report/container-eor'
                      ),
                  },
                  {
                    path: 'print-eor-container',
                    name: 'reportPrintContainerEor',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportEorContainer',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-printcontainersurvey" */ '../views/operational/report/container-eor/print-report'
                      ),
                  },
                  {
                    path: 'repair-eor',
                    name: 'reportContainerRepairEOR',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportEorRepair',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-containerrepair-eor" */ '../views/operational/report/container-repair-eor'
                      ),
                  },
                  {
                    path: 'print-repair-eor',
                    name: 'reportPrintRepairEor',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportEorRepair',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-printrepaireor" */ '../views/operational/report/container-repair-eor/print-report'
                      ),
                  },
                  {
                    path: 'repeat-repair-eor',
                    name: 'reportRepeatRepairEOR',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportEorRepeat',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-repeat-repair-eor" */ '../views/operational/report/container-repeat-repair-eor'
                      ),
                  },
                  {
                    path: 'print-repeat-repair-eor',
                    name: 'reportPrintRepeatRepairEor',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportEorRepeat',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-print-repeat-eor" */ '../views/operational/report/container-repeat-repair-eor/print-report'
                      ),
                  },
                  {
                    path: 'pti-container',
                    name: 'reportPti',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportPtiContainer',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-pti" */ '../views/operational/report/container-pti'
                      ),
                  },
                  {
                    path: 'print-pti-container',
                    name: 'reportPrintPtiContainer',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportPtiContainer',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-printpticontainer" */ '../views/operational/report/container-pti/print-report'
                      ),
                  },
                  {
                    path: 'repair-pti',
                    name: 'reportContainerRepairPTI',
                    meta: {
                      modulName: 'operasional',
                      pageName: 'reportPtiRepair',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-containerrepair-pti" */ '../views/operational/report/container-repair-pti'
                      ),
                  },
                  {
                    path: 'print-repair-pti',
                    name: 'reportPrintRepairPTI',
                    meta: {
                      odulName: 'operasional',
                      pageName: 'reportPtiRepair',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-report-printrepairpti" */ '../views/operational/report/container-repair-pti/print-report'
                      ),
                  },
                ],
              },
              {
                path: 'special-report',
                name: 'specialReport',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "opr-specialreport" */ '../views/operational/special-report'
                  ),
                redirect: '/adm/opr/special-report/standart',
                children: [
                  {
                    path: 'standart',
                    name: 'specialReportStandart',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-specialreport-standart" */ '../views/operational/special-report/standart'
                      ),
                  },
                  {
                    path: 'apl',
                    name: 'specialReportApl',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-specialreport-apl" */ '../views/operational/special-report/apl'
                      ),
                  },
                  {
                    path: 'cma',
                    name: 'specialReportCma',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-specialreport-cma" */ '../views/operational/special-report/cma'
                      ),
                  },
                  {
                    path: 'yml',
                    name: 'specialReportYml',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-specialreport-yml" */ '../views/operational/special-report/yml'
                      ),
                  },
                  {
                    path: 'whl',
                    name: 'specialReportWhl',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-specialreport-whl" */ '../views/operational/special-report/whl'
                      ),
                  },
                  {
                    path: 'scl',
                    name: 'specialReportScl',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-specialreport-scl" */ '../views/operational/special-report/scl'
                      ),
                  },
                  {
                    path: 'sit',
                    name: 'specialReportSit',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-specialreport-sit" */ '../views/operational/special-report/sit'
                      ),
                  },
                  {
                    path: 'dkm',
                    name: 'specialReportDkm',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "opr-specialreport-dkm" */ '../views/operational/special-report/dkm'
                      ),
                  },
                ],
              },
            ],
          },
          {
            path: 'logistic',
            name: 'logistic',
            meta: {},
            redirect: '/adm/logistic/dashboard',
            component: () =>
              import(/* webpackChunkName: "log" */ '../views/logistic'),
            children: [
              {
                path: 'dashboard',
                name: 'lgsDashboard',
                meta: {
                  modulName: 'logistic',
                  pageName: 'dashboardLogistic',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "lgs-dashboard" */ '../views/logistic/dashboard'
                  ),
              },
              {
                path: 'master',
                name: 'lgsMaster',
                meta: {},
                redirect: '/logistic/master/supplier',
                component: () =>
                  import(
                    /* webpackChunkName: "lgs-master" */ '../views/logistic/master'
                  ),
                children: [
                  {
                    path: 'form-supplier/:id?',
                    name: 'lgsFormSupplier',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'masterSupplier',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-master-form-supplier" */ '../views/logistic/master/supplier/form-modal'
                      ),
                  },
                  {
                    path: 'supplier',
                    name: 'lgsSupplier',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'masterSupplier',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-master-supplier" */ '../views/logistic/master/supplier'
                      ),
                  },
                  {
                    path: 'form-alatberat/:id?',
                    name: 'lgsFormAlatBerat',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'masterAlatBerat',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-master-alatberat" */ '../views/logistic/master/alat-berat/form-alatberat'
                      ),
                  },
                  {
                    path: 'alat-berat',
                    name: 'lgsAlatBerat',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'masterAlatBerat',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-master-alatberat" */ '../views/logistic/master/alat-berat'
                      ),
                  },
                  {
                    path: 'gudang',
                    name: 'lgsGudang',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'masterGudang',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-master-gudang" */ '../views/logistic/master/gudang'
                      ),
                  },
                  {
                    path: 'form-gudang/:id?',
                    name: 'lgsFormGudang',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'masterGudang',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-master-form-gudang" */ '../views/logistic/master/gudang/form-gudang'
                      ),
                  },
                  {
                    path: 'form-satuan/:id?',
                    name: 'lgsFormSatuan',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'masterSatuan',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-master-satuan" */ '../views/logistic/master/satuan/form-satuan'
                      ),
                  },
                  {
                    path: 'satuan',
                    name: 'lgsSatuan',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'masterSatuan',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-master-satuan" */ '../views/logistic/master/satuan'
                      ),
                  },
                  {
                    path: 'form-product/:id?',
                    name: 'lgsFormProduct',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'logisticMasterProduk',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-master-formproduct" */ '../views/logistic/master/product/form-product'
                      ),
                  },
                  {
                    path: 'product',
                    name: 'lgsProduct',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'logisticMasterProduk',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-master-product" */ '../views/logistic/master/product'
                      ),
                  },
                  {
                    path: 'kelompok-product',
                    name: 'lgsKelProduk',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'masterKelProduk',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-master-kelproduk" */ '../views/logistic/master/kelompok-produk'
                      ),
                  },
                  {
                    path: 'form-kelompok-product/:id?',
                    name: 'lgsFormKelProduk',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'masterKelProduk',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-master-formkelproduk" */ '../views/logistic/master/kelompok-produk/form-kelompok-product'
                      ),
                  },
                ],
              },
              {
                path: 'saldo-persediaan',
                name: 'lgsSaldoPersediaan',
                meta: {
                  modulName: 'logistic',
                  pageName: 'saldoPersediaan',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "lgs-saldopersediaan" */ '../views/logistic/saldo-persediaan'
                  ),
              },
              {
                path: 'form-saldo-persediaan/:id?',
                name: 'lgsFormSaldoPersediaan',
                meta: {
                  modulName: 'logistic',
                  pageName: 'saldoPersediaan',
                  pageType: 'create_update',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "lgs-form-saldo-persediaan" */ '../views/logistic/saldo-persediaan/form-saldo-persediaan'
                  ),
              },
              {
                path: 'pembelian',
                name: 'lgsPembelian',
                meta: {},
                redirect: '/logistic/pembelian/order-pembelian',
                component: () =>
                  import(
                    /* webpackChunkName: "lgs-beli" */ '../views/logistic/pembelian'
                  ),
                children: [
                  {
                    path: 'form-invoice-pembelian/:id?',
                    name: 'lgsFormOrderPembelian',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'pembelianOrder',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-beli-formpembelian" */ '../views/logistic/pembelian/order-pembelian/form-pembelian'
                      ),
                  },
                  {
                    path: 'order-pembelian',
                    name: 'lgsOrderPembelian',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'pembelianOrder',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-beli-pembelian" */ '../views/logistic/pembelian/order-pembelian'
                      ),
                  },
                  {
                    path: 'print-order-pembelian/:id?',
                    name: 'lgsPrintOrderPembelian',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'pembelianOrder',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-beli-printpembelian" */ '../views/logistic/pembelian/order-pembelian/print-tagihan'
                      ),
                  },
                  {
                    path: 'form-retur-pembelian/:id?',
                    name: 'lgsFormReturPembelian',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'logisticPembelianRetur',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-beli-formreturBeli" */ '../views/logistic/pembelian/retur-pembelian/form-retur'
                      ),
                  },
                  {
                    path: 'retur-pembelian',
                    name: 'lgsReturPembelian',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'logisticPembelianRetur',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-beli-returBeli" */ '../views/logistic/pembelian/retur-pembelian'
                      ),
                  },
                  {
                    path: 'print-retur-pembelian/:id?',
                    name: 'lgsPrintReturPembelian',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'logisticPembelianRetur',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-beli-printreturBeli" */ '../views/logistic/pembelian/retur-pembelian/print-tagihan'
                      ),
                  },
                ],
              },
              {
                path: 'penjualan',
                name: 'lgsPenjualan',
                meta: {},
                redirect: '/logistic/penjualan/order-penjualan',
                component: () =>
                  import(
                    /* webpackChunkName: "lgs-jual" */ '../views/logistic/penjualan'
                  ),
                children: [
                  {
                    path: 'form-invoice-penjualan/:id?',
                    name: 'lgsFormOrderPenjualan',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'penjualanOrder',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-jual-formpenjualan" */ '../views/logistic/penjualan/order-penjualan/form-penjualan'
                      ),
                  },
                  {
                    path: 'order-penjualan',
                    name: 'lgsOrderPenjualan',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'penjualanOrder',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-jual-penjualan" */ '../views/logistic/penjualan/order-penjualan'
                      ),
                  },
                  {
                    path: 'print-order-penjualan/:id?',
                    name: 'lgsPrintPenjualan',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'penjualanOrder',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-jual-printpenjualan" */ '../views/logistic/penjualan/order-penjualan/print-tagihan'
                      ),
                  },
                  {
                    path: 'retur-penjualan',
                    name: 'lgsReturPenjualan',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'logisticPenjualanRetur',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-jual-returBeli" */ '../views/logistic/penjualan/retur-penjualan'
                      ),
                  },
                  {
                    path: 'print-retur-penjualan/:id?',
                    name: 'lgsPrintReturPenjualan',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'logisticPenjualanRetur',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-jual-printreturJual" */ '../views/logistic/penjualan/retur-penjualan/print-tagihan'
                      ),
                  },
                  {
                    path: 'form-retur-penjualan/:id?',
                    name: 'lgsFormReturPenjualan',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'logisticPenjualanRetur',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-jual-returpenjualan" */ '../views/logistic/penjualan/retur-penjualan/form-retur'
                      ),
                  },
                ],
              },
              {
                path: 'stok',
                name: 'lgsStock',
                meta: {},
                redirect: '/logistic/stok/stok-masuk',
                component: () =>
                  import(
                    /* webpackChunkName: "lgs-stok" */ '../views/logistic/stok'
                  ),
                children: [
                  // {
                  //   path: 'form-stokmasuk',
                  //   name: 'lgsFormStokMasuk',
                  //   meta: {},
                  //   component: () =>
                  //     import(
                  //       /* webpackChunkName: "lgs-stok-formstokmasuk" */ '../views/logistic/stok/stok-masuk/form-stokmasuk'
                  //     ),
                  // },
                  // {
                  //   path: 'stok-masuk',
                  //   name: 'lgsStokMasuk',
                  //   meta: {},
                  //   component: () =>
                  //     import(
                  //       /* webpackChunkName: "lgs-stok-stokmasuk" */ '../views/logistic/stok/stok-masuk'
                  //     ),
                  // },
                  // {
                  //   path: 'form-stokkeluar',
                  //   name: 'lgsFormStokKeluar',
                  //   meta: {},
                  //   component: () =>
                  //     import(
                  //       /* webpackChunkName: "lgs-stok-formstokkeluar" */ '../views/logistic/stok/stok-keluar/form-stokkeluar'
                  //     ),
                  // },
                  // {
                  //   path: 'stok-keluar',
                  //   name: 'lgsStokKeluar',
                  //   meta: {},
                  //   component: () =>
                  //     import(
                  //       /* webpackChunkName: "lgs-stok-stokkeluar" */ '../views/logistic/stok/stok-keluar'
                  //     ),
                  // },
                  {
                    path: 'form-stok/:id?',
                    name: 'lgsFormPenyesuaianStok',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'penyesuaianStok',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-stok-formpenyesuaianstok" */ '../views/logistic/stok/penyesuaian-stok/form-penyesuaian'
                      ),
                  },
                  {
                    path: 'penyesuaian-stok',
                    name: 'lgsPenyesuaianStok',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'penyesuaianStok',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-stok-penyesuaianstok" */ '../views/logistic/stok/penyesuaian-stok'
                      ),
                  },
                ],
              },
              {
                path: 'laporan',
                name: 'lgsLaporan',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "lgs-laporan" */ '../views/logistic/laporan'
                  ),
                children: [
                  // {
                  //   path: 'supplier-produk',
                  //   name: 'lgsReportSupplierProduk',
                  //   meta: {},
                  //   component: () =>
                  //     import(
                  //       /* webpackChunkName: "lgs-lapSupplierProduk" */ '../views/logistic/laporan/supplier-produk'
                  //     ),
                  // },
                  // {
                  //   path: 'pakai-unit',
                  //   name: 'lgsReportPakaiUnit',
                  //   meta: {},
                  //   component: () =>
                  //     import(
                  //       /* webpackChunkName: "lgs-lapPakaiUnit" */ '../views/logistic/laporan/pakai-unit'
                  //     ),
                  // },
                  // {
                  //   path: 'retur-beli',
                  //   name: 'lgsReportReturBeli',
                  //   meta: {},
                  //   component: () =>
                  //     import(
                  //       /* webpackChunkName: "lgs-lapReturBeli" */ '../views/logistic/laporan/retur-beli'
                  //     ),
                  // },
                  // {
                  //   path: 'stok-masuk',
                  //   name: 'lgsReportStokMasuk',
                  //   meta: {},
                  //   component: () =>
                  //     import(
                  //       /* webpackChunkName: "lgs-lapStokMasuk" */ '../views/logistic/laporan/stok-masuk'
                  //     ),
                  // },
                  // {
                  //   path: 'stok-keluar',
                  //   name: 'lgsReportStokKeluar',
                  //   meta: {},
                  //   component: () =>
                  //     import(
                  //       /* webpackChunkName: "lgs-lapStokKeluar" */ '../views/logistic/laporan/stok-keluar'
                  //     ),
                  // },
                  // {
                  //   path: 'penyesuaian',
                  //   name: 'lgsReportPenyesuaian',
                  //   meta: {},
                  //   component: () =>
                  //     import(
                  //       /* webpackChunkName: "lgs-lapPenyesuaian" */ '../views/logistic/laporan/penyesuaian'
                  //     ),
                  // },
                  {
                    path: 'pemakaian-alat',
                    name: 'lapPemakaianAlat',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'lapPemakaianAlat',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-lapPemakaianAlat" */ '../views/logistic/laporan/pemakaian-alat'
                      ),
                  },
                  {
                    path: 'print-pemakaian-alat',
                    name: 'lapPemakaianAlatPrint',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'lapPemakaianAlat',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-lapPemakaianAlat" */ '../views/logistic/laporan/pemakaian-alat/print-report'
                      ),
                  },
                  {
                    path: 'order-pembelian',
                    name: 'lapOrderPembelian',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'lapOrderPembelian',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-lapOrderPembelian" */ '../views/logistic/laporan/pembelian'
                      ),
                  },
                  {
                    path: 'print-order-pembelian',
                    name: 'lapOrderPembelianPrint',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'lapOrderPembelian',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-lapOrderPembelian" */ '../views/logistic/laporan/pembelian/print-report'
                      ),
                  },
                  {
                    path: 'order-penjualan',
                    name: 'lapOrderPenjualan',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'lapOrderPenjualan',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-lapOrderPenjualan" */ '../views/logistic/laporan/penjualan'
                      ),
                  },
                  {
                    path: 'print-order-penjualan',
                    name: 'lapOrderPenjualanPrint',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'lapOrderPenjualan',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-lapOrderPenjualan" */ '../views/logistic/laporan/penjualan/print-report'
                      ),
                  },
                  {
                    path: 'kartu-stok',
                    name: 'lgsReportKartuStok',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'lapKartuStok',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-lapKartuStok" */ '../views/logistic/laporan/kartu-stok'
                      ),
                  },
                  {
                    path: 'view-stok',
                    name: 'lgsReportKartuViewStok',
                    meta: {
                      modulName: 'logistic',
                      pageName: 'lapKartuStok',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "lgs-lapKartuSViewtok" */ '../views/logistic/laporan/kartu-stok/view-report'
                      ),
                  },
                ],
              },
            ],
          },
          {
            path: 'fin',
            name: 'finance',
            meta: {},
            redirect: '/adm/fin/dashboard',
            component: () =>
              import(/* webpackChunkName: "finance" */ '../views/finance'),
            children: [
              {
                path: 'dashboard',
                name: 'financeDashboard',
                meta: {
                  modulName: 'finance',
                  pageName: 'dashboardFinance',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "fin-dashboard" */ '../views/finance/dashboard'
                  ),
              },
              {
                path: 'master',
                name: 'financeMaster',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "fin-master" */ '../views/finance/master'
                  ),
                redirect: '/fin/master/rekening-perkiraan',
                children: [
                  {
                    path: 'rekening-perkiraan',
                    name: 'financeMasterRekening',
                    meta: {
                      modulName: 'finance',
                      pageName: 'masterRekeningPerkiraan',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-master-rekening" */ '../views/finance/master/rekening-perkiraan'
                      ),
                  },
                  {
                    path: 'klasifikasi-akun',
                    name: 'financeMasterKlasifikasiAkun',
                    meta: {
                      modulName: 'finance',
                      pageName: 'masterKlasifikasiAkun',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-master-klasifikasi" */ '../views/finance/master/klasifikasi-akun'
                      ),
                  },
                  {
                    path: 'akun-penting',
                    name: 'financeMasterAkunPenting',
                    meta: {
                      modulName: 'finance',
                      pageName: 'masterAkunPenting',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-master-akunpenting" */ '../views/finance/master/akun-penting'
                      ),
                  },
                  {
                    path: 'mata-uang',
                    name: 'financeMasterMataUang',
                    meta: {
                      modulName: 'finance',
                      pageName: 'masterMataUang',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-master-matauang" */ '../views/finance/master/mata-uang'
                      ),
                  },
                  {
                    path: 'nilai-tukar',
                    name: 'financeMasterNilaiTukar',
                    meta: {
                      modulName: 'finance',
                      pageName: 'masterNiaiTukar',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-master-nilaitukar" */ '../views/finance/master/mata-uang/nilai-tukar'
                      ),
                  },
                  {
                    path: 'form-mata-uang/:id?',
                    name: 'financeMasterFormMataUang',
                    meta: {
                      modulName: 'finance',
                      pageName: 'masterMataUang',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-master-formmatauang" */ '../views/finance/master/mata-uang/form-mata-uang'
                      ),
                  },
                  {
                    path: 'department',
                    name: 'financeMasterDepartment',
                    meta: {
                      modulName: 'finance',
                      pageName: 'masterDepartment',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-master-department" */ '../views/finance/master/departement'
                      ),
                  },
                  {
                    path: 'produk',
                    name: 'financeMasterProduk',
                    meta: {
                      modulName: 'finance',
                      pageName: 'financeMasterProduk',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-master-produk" */ '../views/finance/master/product'
                      ),
                  },
                  {
                    path: 'form-produk/:id?',
                    name: 'financeMasterFormProduk',
                    meta: {
                      modulName: 'finance',
                      pageName: 'financeMasterProduk',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-master-formproduk" */ '../views/logistic/master/product/form-product'
                      ),
                  },
                  {
                    path: 'pajak',
                    name: 'financeMasterPajak',
                    meta: {
                      modulName: 'finance',
                      pageName: 'masterPajak',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-master-pajak" */ '../views/finance/master/pajak'
                      ),
                  },
                  {
                    path: 'kelompok-harta',
                    name: 'financeMasterKelompokHarta',
                    meta: {
                      modulName: 'finance',
                      pageName: 'masterKelompokHarta',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-master-kelompok-harta" */ '../views/finance/master/kelompok-harta'
                      ),
                  },
                  {
                    path: 'harta-tetap',
                    name: 'financeMasterHartaTetap',
                    meta: {
                      modulName: 'finance',
                      pageName: 'masterHartaTetap',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-master-hartatetap" */ '../views/finance/master/harta-tetap'
                      ),
                  },
                  {
                    path: 'form-harta-tetap/:id?',
                    name: 'financeMasterFormHartaTetap',
                    meta: {
                      modulName: 'finance',
                      pageName: 'masterHartaTetap',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-master-formhartatetap" */ '../views/finance/master/harta-tetap/form-harta-tetap'
                      ),
                  },
                ],
              },
              {
                path: 'buku-besar',
                name: 'finBukuBesar',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "fin-bukubesar" */ '../views/finance/buku-besar'
                  ),
                redirect: '/buku-besar/buku-besar',
                children: [
                  {
                    path: 'buku-besar',
                    name: 'finBukuBesarUtama',
                    meta: {
                      modulName: 'finance',
                      pageName: 'bukuBesar',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-bukubesar-utama" */ '../views/finance/buku-besar/buku-besar'
                      ),
                  },
                  {
                    path: 'journal',
                    name: 'finBukuBesarJournal',
                    meta: {
                      modulName: 'finance',
                      pageName: 'jurnalUmum',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-bukubesar-journal" */ '../views/finance/buku-besar/journal-umum'
                      ),
                  },
                  {
                    path: 'form-journal/:id?',
                    name: 'finFormJournal',
                    meta: {
                      modulName: 'finance',
                      pageName: 'jurnalUmum',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-bukubesar-form-journal" */ '../views/finance/buku-besar/journal-umum/form-journal-umum'
                      ),
                  },
                ],
              },
              {
                path: 'saldo',
                name: 'finSaldo',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "fin-saldo" */ '../views/finance/saldo'
                  ),
                redirect: '/fin/saldo/saldo-awal',
                children: [
                  {
                    path: 'saldo-awal',
                    name: 'finSaldoAwal',
                    meta: {
                      modulName: 'finance',
                      pageName: 'saldoAwalSaldo',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-saldo-saldoawal" */ '../views/finance/saldo/saldo-awal'
                      ),
                  },
                  {
                    path: 'saldo-piutang',
                    name: 'finSaldoPiutang',
                    meta: {
                      modulName: 'finance',
                      pageName: 'saldoAwalPiutang',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-saldo-saldopiutang" */ '../views/finance/saldo/saldo-piutang'
                      ),
                  },
                  {
                    path: 'form-saldo-piutang/:id?',
                    name: 'finFormSaldoPiutang',
                    meta: {
                      modulName: 'finance',
                      pageName: 'saldoAwalPiutang',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-saldo-form-saldo-piutang" */ '../views/finance/saldo/saldo-piutang/form-saldo-piutang'
                      ),
                  },
                  {
                    path: 'saldo-hutang',
                    name: 'finSaldoHutang',
                    meta: {
                      modulName: 'finance',
                      pageName: 'saldoAwalHutang',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-saldo-saldohutang" */ '../views/finance/saldo/saldo-hutang'
                      ),
                  },
                  {
                    path: 'form-saldo-hutang/:id?',
                    name: 'finFormSaldoHutang',
                    meta: {
                      modulName: 'finance',
                      pageName: 'saldoAwalHutang',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-saldo-form-saldo-hutang" */ '../views/finance/saldo/saldo-hutang/form-saldo-hutang'
                      ),
                  },
                ],
              },
              {
                path: 'penjualan',
                name: 'finPenjualan',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "fin-penjualan" */ '../views/finance/penjualan'
                  ),
                redirect: '/fin/penjualan/invoice-penjualan',
                children: [
                  {
                    path: 'depo-cash',
                    name: 'finDepoTunaiList',
                    meta: {
                      modulName: 'finance',
                      pageName: 'penjualanInvDepoTunai',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-penjualan-depo-cash" */ '../views/finance/penjualan/depo-cash'
                      ),
                  },
                  {
                    path: 'form-depo-cash/:id?',
                    name: 'finDepoTunai',
                    meta: {
                      modulName: 'finance',
                      pageName: 'penjualanInvDepoTunai',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-penjualan-form-depo-cash" */ '../views/finance/penjualan/depo-cash/form-depo-cash'
                      ),
                  },
                  {
                    path: 'depo-credit',
                    name: 'finDepoCredit',
                    meta: {
                      modulName: 'finance',
                      pageName: 'penjualanInvDepoKredit',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-penjualan-depo-credit" */ '../views/finance/penjualan/depo-credit'
                      ),
                  },
                  {
                    path: 'print-depo-credit/:id?',
                    name: 'finPrintDepoCredit',
                    meta: {
                      modulName: 'finance',
                      pageName: 'penjualanInvDepoKredit',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-penjualan-print-depo-credit" */ '../views/finance/penjualan/depo-credit/print-tagihan'
                      ),
                  },
                  {
                    path: 'form-depo-credit/:id?',
                    name: 'finFormDepoCredit',
                    meta: {
                      modulName: 'finance',
                      pageName: 'penjualanInvDepoKredit',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-penjualan-form-depo-credit" */ '../views/finance/penjualan/depo-credit/form-depo-credit'
                      ),
                  },
                  {
                    path: 'form-invoice-penjualan/:id?',
                    name: 'finInvPenjualan',
                    meta: {
                      modulName: 'finance',
                      pageName: 'penjualanInv',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-penjualan-form-invjual" */ '../views/finance/penjualan/invoice-penjualan/form-penjualan'
                      ),
                  },
                  {
                    path: 'invoice-penjualan',
                    name: 'finInvoicePenjualan',
                    meta: {
                      modulName: 'finance',
                      pageName: 'penjualanInv',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-penjualan-invoice" */ '../views/finance/penjualan/invoice-penjualan'
                      ),
                  },
                  {
                    path: 'print-invoice-penjualan/:id?',
                    name: 'finPrintInvoicePenjualan',
                    meta: {
                      modulName: 'finance',
                      pageName: 'penjualanInv',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-print-penjualan-invoice" */ '../views/finance/penjualan/invoice-penjualan/print-tagihan'
                      ),
                  },
                  {
                    path: 'form-uang-muka-jual/:id?',
                    name: 'finFormUMPenjualan',
                    meta: {
                      modulName: 'finance',
                      pageName: 'penjualanUangMuka',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-um-form-penjualan" */ '../views/finance/penjualan/uang-muka-jual/form-uang-muka'
                      ),
                  },
                  {
                    path: 'uang-muka-penjualan',
                    name: 'finUMPenjualan',
                    meta: {
                      modulName: 'finance',
                      pageName: 'penjualanUangMuka',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-um-penjualan" */ '../views/finance/penjualan/uang-muka-jual'
                      ),
                  },
                  {
                    path: 'piutang-usaha',
                    name: 'finPiutangUsaha',
                    meta: {
                      modulName: 'finance',
                      pageName: 'penjualanPiutang',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-piutang-usaha" */ '../views/finance/penjualan/piutang-usaha'
                      ),
                  },
                  {
                    path: 'piutang-detail/:id?',
                    name: 'finPiutangDetail',
                    meta: {
                      modulName: 'finance',
                      pageName: 'penjualanPiutang',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-piutang-detail" */ '../views/finance/penjualan/piutang-usaha/detail-piutang'
                      ),
                  },
                  {
                    path: 'pembayaran-piutang-usaha',
                    name: 'finPembayaranPiutangUsaha',
                    meta: {
                      modulName: 'finance',
                      pageName: 'penjualanBayarPiutang',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-bayar-piutang-usaha" */ '../views/finance/penjualan/pembayaran-piutang'
                      ),
                  },
                  {
                    path: 'print-bayar-piutang/:id?',
                    name: 'finPrintBayarPiutang',
                    meta: {
                      modulName: 'finance',
                      pageName: 'penjualanBayarPiutang',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-print-bayar-piutang" */ '../views/finance/penjualan/pembayaran-piutang/print-bayar-piutang'
                      ),
                  },
                  {
                    path: 'form-pembayaran-piutang/:id?',
                    name: 'finFormPembayaranPiutangUsaha',
                    meta: {
                      modulName: 'finance',
                      pageName: 'penjualanBayarPiutang',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-form-bayar-piutang-usaha" */ '../views/finance/penjualan/pembayaran-piutang/form-pembayaran-piutang'
                      ),
                  },
                  {
                    path: 'form-retur-penjualan/:id?',
                    name: 'finFormReturPenjualan',
                    meta: {
                      modulName: 'finance',
                      pageName: 'financePenjualanRetur',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-form-retur-penjualan" */ '../views/logistic/penjualan/retur-penjualan/form-retur'
                      ),
                  },
                  {
                    path: 'retur-penjualan',
                    name: 'finReturPenjualan',
                    meta: {
                      modulName: 'finance',
                      pageName: 'financePenjualanRetur',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-retur-penjualan" */ '../views/logistic/penjualan/retur-penjualan'
                      ),
                  },
                  {
                    path: 'print-retur-penjualan/:id?',
                    name: 'finPrintReturPenjualan',
                    meta: {
                      modulName: 'finance',
                      pageName: 'financePenjualanRetur',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-jual-printreturJual" */ '../views/logistic/penjualan/retur-penjualan/print-tagihan'
                      ),
                  },
                ],
              },
              {
                path: 'penjualan-lain',
                name: 'penjualanLain',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "fin-transaksi" */ '../views/finance/penjualan-detail'
                  ),
                redirect: '/adm/fin/penjualan-lain/storage',
                children: [
                  {
                    path: 'other-in',
                    name: 'transOtherInFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transOtherIn',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-other-in" */ '../views/finance/penjualan-detail/other-in'
                      ),
                  },
                  {
                    path: 'print-trans-other-in',
                    name: 'transOtherInPrintFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transOtherIn',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-other-in" */ '../views/finance/penjualan-detail/other-in/print-other-in'
                      ),
                  },
                  {
                    path: 'document-fee-in',
                    name: 'transDocumentFeeInFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transDocumentFeeIn',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-document-fee" */ '../views/finance/penjualan-detail/document-fee-in'
                      ),
                  },
                  {
                    path: 'print-trans-doc-in',
                    name: 'transDocumentFeeInPrintFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transDocumentFeeIn',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-document-fee" */ '../views/finance/penjualan-detail/document-fee-in/print-doc-in'
                      ),
                  },
                  {
                    path: 'other-out',
                    name: 'transOtherOutFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transOtherOut',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-other-out" */ '../views/finance/penjualan-detail/other-out'
                      ),
                  },
                  {
                    path: 'print-trans-other-out',
                    name: 'transOtherOutPrintFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transOtherOut',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-other-out" */ '../views/finance/penjualan-detail/other-out/print-other-out'
                      ),
                  },
                  {
                    path: 'document-fee-out',
                    name: 'transDocumentFeeOutFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transDocumentFeeOut',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-document-fee-out" */ '../views/finance/penjualan-detail/document-fee-out'
                      ),
                  },
                  {
                    path: 'print-trans-doc-out',
                    name: 'transDocumentFeeOutPrintFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transDocumentFeeOut',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-document-fee" */ '../views/finance/penjualan-detail/document-fee-out/print-doc-out'
                      ),
                  },
                  {
                    path: 'storage',
                    name: 'transStorageFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transStorage',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-storage" */ '../views/finance/penjualan-detail/storage'
                      ),
                  },
                  {
                    path: 'print-trans-storage',
                    name: 'transPrintStorageFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transStorage',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-storage" */ '../views/finance/penjualan-detail/storage/print-storage'
                      ),
                  },
                  {
                    path: 'lift-off',
                    name: 'transLiftOffFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transLiftOff',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-lift-off" */ '../views/finance/penjualan-detail/lift-off'
                      ),
                  },
                  {
                    path: 'print-trans-lift-off',
                    name: 'transPrintLiftOffFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transLiftOff',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-lift-off" */ '../views/finance/penjualan-detail/lift-off/print-lift-off'
                      ),
                  },
                  {
                    path: 'lift-on',
                    name: 'transLiftOnFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transLiftOn',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-lift-on" */ '../views/finance/penjualan-detail/lift-on'
                      ),
                  },
                  {
                    path: 'print-trans-lift-on',
                    name: 'transPrintLiftOnFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transLiftOn',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-lift-on" */ '../views/finance/penjualan-detail/lift-on/print-lift-on'
                      ),
                  },
                  {
                    path: 'cleaning',
                    name: 'transCleaningFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transCleaning',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-cleaning" */ '../views/finance/penjualan-detail/cleaning'
                      ),
                  },
                  {
                    path: 'print-trans-cleaning',
                    name: 'transPrintCleaningFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transCleaning',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-cleaning" */ '../views/finance/penjualan-detail/cleaning/print-cleaning'
                      ),
                  },
                  {
                    path: 'truck-booking',
                    name: 'transTruckBookingFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transTruckBooking',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-truck-booking" */ '../views/finance/penjualan-detail/truck-booking'
                      ),
                  },
                  {
                    path: 'print-trans-truck-booking',
                    name: 'transPrintTruckBookingFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transTruckBooking',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-truck-booking" */ '../views/finance/penjualan-detail/truck-booking/print-truck-booking'
                      ),
                  },
                  {
                    path: 'truck-interchange',
                    name: 'transTruckInterchangeFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transTruckInterchange',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-truck-interchange" */ '../views/finance/penjualan-detail/truck-interchange'
                      ),
                  },
                  {
                    path: 'print-trans-truck-interchange',
                    name: 'transPrintTrucInterchangeFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transTruckInterchange',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-truck-interchange" */ '../views/finance/penjualan-detail/truck-interchange/print-truck-interchange'
                      ),
                  },
                  {
                    path: 'eor',
                    name: 'transEorFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transEor',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-eor" */ '../views/finance/penjualan-detail/eor'
                      ),
                  },
                  {
                    path: 'print-trans-eor',
                    name: 'transPrintEORFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transEor',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-eor" */ '../views/finance/penjualan-detail/eor/print-eor'
                      ),
                  },
                  {
                    path: 'pti',
                    name: 'transPtiFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transPti',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-pti" */ '../views/finance/penjualan-detail/pti'
                      ),
                  },
                  {
                    path: 'print-trans-pti',
                    name: 'transPrintPtiFin',
                    meta: {
                      modulName: 'finance',
                      pageName: 'transPti',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-trans-pti" */ '../views/finance/penjualan-detail/pti/print-pti'
                      ),
                  },
                ],
              },
              {
                path: 'pembelian',
                name: 'finPembelian',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "fin-pembelian" */ '../views/finance/pembelian'
                  ),
                redirect: '/fin/pembelian/invoice-pembelian',
                children: [
                  {
                    path: 'invoice-pembelian',
                    name: 'finInvPembelian',
                    meta: {
                      modulName: 'finance',
                      pageName: 'pembelianInvoice',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-inv-pembelian" */ '../views/finance/pembelian/invoice-pembelian'
                      ),
                  },
                  {
                    path: 'form-invoice-pembelian/:id?',
                    name: 'finInvBeli',
                    meta: {
                      modulName: 'finance',
                      pageName: 'pembelianInvoice',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-pembelian-form-invjual" */ '../views/finance/pembelian/invoice-pembelian/form-pembelian'
                      ),
                  },
                  {
                    path: 'print-invoice-pembelian/:id?',
                    name: 'finPrintInvBeli',
                    meta: {
                      modulName: 'finance',
                      pageName: 'pembelianInvoice',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-pembelian-form-invjual" */ '../views/finance/pembelian/invoice-pembelian/print-tagihan'
                      ),
                  },
                  {
                    path: 'hutang-usaha',
                    name: 'finHutangUsaha',
                    meta: {
                      modulName: 'finance',
                      pageName: 'pembelianHutang',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-hutang-usaha" */ '../views/finance/pembelian/hutang-usaha'
                      ),
                  },
                  {
                    path: 'hutang-detail/:id?',
                    name: 'finHitungDetail',
                    meta: {
                      modulName: 'finance',
                      pageName: 'pembelianHutang',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-hutang-detail" */ '../views/finance/pembelian/hutang-usaha/detail-hutang'
                      ),
                  },
                  {
                    path: 'pembayaran-hutang-usaha',
                    name: 'finPembayaranHutangUsaha',
                    meta: {
                      modulName: 'finance',
                      pageName: 'pembelianBayarHutang',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-bayar-hutang-usaha" */ '../views/finance/pembelian/pembayaran-hutang'
                      ),
                  },
                  {
                    path: 'print-bayar-hutang/:id?',
                    name: 'finPrintBayarHutang',
                    meta: {
                      modulName: 'finance',
                      pageName: 'pembelianBayarHutang',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-print-bayar-hutang" */ '../views/finance/pembelian/pembayaran-hutang/print-bayar-hutang'
                      ),
                  },
                  {
                    path: 'form-pembayaran-hutang/:id?',
                    name: 'finFormPembayaranHutangUsaha',
                    meta: {
                      modulName: 'finance',
                      pageName: 'pembelianBayarHutang',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-form-bayar-hutang-usaha" */ '../views/finance/pembelian/pembayaran-hutang/form-pembayaran-hutang'
                      ),
                  },
                  {
                    path: 'form-uang-muka-beli/:id?',
                    name: 'finFormUMPembelian',
                    meta: {
                      modulName: 'finance',
                      pageName: 'pembelianUangMuka',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-um-form-pembelian" */ '../views/finance/pembelian/uang-muka-beli/form-uang-muka'
                      ),
                  },
                  {
                    path: 'uang-muka-pembelian',
                    name: 'finUMPembelian',
                    meta: {
                      modulName: 'finance',
                      pageName: 'pembelianUangMuka',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-um-pembelian" */ '../views/finance/pembelian/uang-muka-beli'
                      ),
                  },
                  {
                    path: 'form-retur-pembelian/:id?',
                    name: 'finFormReturPembelian',
                    meta: {
                      modulName: 'finance',
                      pageName: 'financePembelianRetur',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-form-retur-pembelian" */ '../views/logistic/pembelian/retur-pembelian/form-retur'
                      ),
                  },
                  {
                    path: 'retur-pembelian',
                    name: 'finReturPembelian',
                    meta: {
                      modulName: 'finance',
                      pageName: 'financePembelianRetur',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-retur-pembelian" */ '../views/logistic/pembelian/retur-pembelian'
                      ),
                  },
                  {
                    path: 'print-retur-pembelian/:id?',
                    name: 'finPrintReturPembelian',
                    meta: {
                      modulName: 'finance',
                      pageName: 'financePembelianRetur',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-beli-printreturBeli" */ '../views/logistic/pembelian/retur-pembelian/print-tagihan'
                      ),
                  },
                ],
              },
              {
                path: 'kas-bank',
                name: 'finKasBank',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "fin-kas-bank" */ '../views/finance/kas-bank'
                  ),
                redirect: '/adm/fin/kas-bank/kas-masuk',
                children: [
                  {
                    path: 'kas-masuk',
                    name: 'finKasMasuk',
                    meta: {
                      modulName: 'finance',
                      pageName: 'kasMasuk',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-kas-masuk" */ '../views/finance/kas-bank/kas-masuk'
                      ),
                  },
                  {
                    path: 'form-kas-masuk/:id?',
                    name: 'finFormKasMasuk',
                    meta: {
                      modulName: 'finance',
                      pageName: 'kasMasuk',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-form-kas-masuk" */ '../views/finance/kas-bank/kas-masuk/form-kas-masuk'
                      ),
                  },
                  {
                    path: 'kas-keluar',
                    name: 'finKasKeluar',
                    meta: {
                      modulName: 'finance',
                      pageName: 'kasKeluar',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-kas-keluar" */ '../views/finance/kas-bank/kas-keluar'
                      ),
                  },
                  {
                    path: 'form-kas-keluar/:id?',
                    name: 'finFormKasKeluar',
                    meta: {
                      modulName: 'finance',
                      pageName: 'kasKeluar',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-form-kas-keluar" */ '../views/finance/kas-bank/kas-keluar/form-kas-keluar'
                      ),
                  },
                  {
                    path: 'transfer-kas',
                    name: 'finTransferKas',
                    meta: {
                      modulName: 'finance',
                      pageName: 'kasTransfer',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-transfer-kas" */ '../views/finance/kas-bank/transfer-kas'
                      ),
                  },
                  {
                    path: 'form-transfer-kas/:id?',
                    name: 'finFormTransferKas',
                    meta: {
                      modulName: 'finance',
                      pageName: 'kasTransfer',
                      pageType: 'create_update',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-form-trasfer-kas" */ '../views/finance/kas-bank/transfer-kas/form-transfer-kas'
                      ),
                  },
                  {
                    path: 'giro-masuk',
                    name: 'finGiroMasuk',
                    meta: {
                      modulName: 'finance',
                      pageName: 'giroMasuk',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-giro-masuk" */ '../views/finance/kas-bank/giro-masuk'
                      ),
                  },
                  {
                    path: 'giro-keluar',
                    name: 'finGiroKeluar',
                    meta: {
                      modulName: 'finance',
                      pageName: 'giroKeluar',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-giro-keluar" */ '../views/finance/kas-bank/giro-keluar'
                      ),
                  },
                ],
              },
              {
                path: 'faktur-pajak',
                name: 'finFakturPajak',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "fin-faktur-pajak" */ '../views/finance/faktur-pajak'
                  ),
                redirect: '/adm/fin/faktur-pajak/setting-faktur',
                children: [
                  {
                    path: 'setting-faktur',
                    name: 'finSettingFaktur',
                    meta: {
                      modulName: 'finance',
                      pageName: 'SettingFaktur',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-setting-faktur" */ '../views/finance/faktur-pajak/setting-faktur'
                      ),
                  },
                  {
                    path: 'file-faktur',
                    name: 'finFileFaktur',
                    meta: {
                      modulName: 'finance',
                      pageName: 'FileFaktur',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-file-faktur" */ '../views/finance/faktur-pajak/file-faktur'
                      ),
                  },
                  {
                    path: 'generate-faktur',
                    name: 'finGenerateFaktur',
                    meta: {
                      modulName: 'finance',
                      pageName: 'GenerateFaktur',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-generate-faktur" */ '../views/finance/faktur-pajak/generate-faktur'
                      ),
                  },
                  {
                    path: 'form-generate-faktur',
                    name: 'finFormGenerateFaktur',
                    meta: {
                      modulName: 'finance',
                      pageName: 'GenerateFaktur',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-generate-faktur" */ '../views/finance/faktur-pajak/generate-faktur/form-faktur'
                      ),
                  },
                  {
                    path: 'laporan-faktur',
                    name: 'finLaporanFaktur',
                    meta: {
                      modulName: 'finance',
                      pageName: 'LaporanFaktur',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-faktur" */ '../views/finance/faktur-pajak/laporan-faktur'
                      ),
                  },
                ],
              },
              {
                path: 'laporan',
                name: 'finLaporan',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "fin-laporan" */ '../views/finance/laporan'
                  ),
                redirect: '/adm/fin/laporan/laba-rugi',
                children: [
                  {
                    path: 'faktur-pajak',
                    name: 'finLapFakturPajak',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapFakturPajak',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-faktur-pajak" */ '../views/finance/laporan/faktur-pajak'
                      ),
                  },
                  {
                    path: 'laba-rugi',
                    name: 'finLapLabaRugi',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapLabaRugi',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-labarugi" */ '../views/finance/laporan/laba-rugi'
                      ),
                  },
                  {
                    path: 'print-laba-rugi',
                    name: 'finLapPrintLabaRugi',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapLabaRugiSetahun',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-printlabarugi" */ '../views/finance/laporan/laba-rugi/print-laba-rugi'
                      ),
                  },
                  {
                    path: 'laba-rugi-setahun',
                    name: 'finLapLabaRugiSetahun',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapLabaRugiSetahun',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-labarugi-setahun" */ '../views/finance/laporan/laba-rugi-setahun'
                      ),
                  },
                  {
                    path: 'print-laba-rugi-setahun',
                    name: 'finLapPrintLabaRugiSetahun',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapLabaRugiSetahun',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-printlabarugi-setahun" */ '../views/finance/laporan/laba-rugi-setahun/print-laba-rugi'
                      ),
                  },
                  {
                    path: 'neraca-saldo',
                    name: 'finLapNeraca',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapNeraca',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-neraca" */ '../views/finance/laporan/neraca'
                      ),
                  },
                  {
                    path: 'print-neraca-saldo',
                    name: 'finLapPrintNeracaSaldo',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapNeraca',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-printneraca-saldo" */ '../views/finance/laporan/neraca/print-neraca'
                      ),
                  },
                  {
                    path: 'buku-besar',
                    name: 'finLapBukuBesar',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapBukuBesar',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-bukubesar" */ '../views/finance/laporan/buku-besar'
                      ),
                  },
                  {
                    path: 'print-buku-besar',
                    name: 'finLapPrintBukuBesar',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapBukuBesar',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-printbukubesar" */ '../views/finance/laporan/buku-besar/print-bukubesar'
                      ),
                  },
                  {
                    path: 'journal',
                    name: 'finLapJournal',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapJurnal',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-journal" */ '../views/finance/laporan/journal'
                      ),
                  },
                  {
                    path: 'print-journal',
                    name: 'finLapPrintJournal',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapJurnal',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-printjournal" */ '../views/finance/laporan/journal/print-journal'
                      ),
                  },
                  {
                    path: 'kartu-piutang',
                    name: 'finLapKartuPiutang',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapKartuPiutang',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-piutang" */ '../views/finance/laporan/kartu-piutang'
                      ),
                  },
                  {
                    path: 'print-kartu-piutang',
                    name: 'finLapPrintKartuPiutang',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapKartuPiutang',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-printpiutang" */ '../views/finance/laporan/kartu-piutang/print-piutang'
                      ),
                  },
                  {
                    path: 'kartu-hutang',
                    name: 'finLapKartuHutang',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapKartuHutang',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-hutang" */ '../views/finance/laporan/kartu-hutang'
                      ),
                  },
                  {
                    path: 'print-kartu-hutang',
                    name: 'finLapPrintKartuHutang',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapKartuHutang',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-printhutang" */ '../views/finance/laporan/kartu-hutang/print-hutang'
                      ),
                  },
                  {
                    path: 'arus-kas',
                    name: 'finLapArusKas',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapArusKas',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-arus-kas" */ '../views/finance/laporan/arus-kas'
                      ),
                  },
                  {
                    path: 'print-arus-kas',
                    name: 'finLapPrintArusKas',
                    meta: {
                      modulName: 'finance',
                      pageName: 'lapArusKas',
                      pageType: 'print',
                      printReport: true,
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-laporan-printhutang" */ '../views/finance/laporan/arus-kas/print-arus-kas'
                      ),
                  },
                ],
              },
              {
                path: 'tutup-buku',
                name: 'finTutupBuku',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "fin-tutupbuku" */ '../views/finance/tutup-buku'
                  ),
                redirect: '/fin/tutup-buku/bulanan',
                children: [
                  {
                    path: 'bulanan',
                    name: 'finTutupBukuBulanan',
                    meta: {
                      modulName: 'finance',
                      pageName: 'tutupBukuBulanan',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-tutupbuku-bulanan" */ '../views/finance/tutup-buku/bulanan'
                      ),
                  },
                  {
                    path: 'tahunan',
                    name: 'finTutupBukuTahunan',
                    meta: {
                      modulName: 'finance',
                      pageName: 'tutupBukuTahunan',
                      pageType: 'view',
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "fin-tutupbuku-tahunan" */ '../views/finance/tutup-buku/tahunan'
                      ),
                  },
                ],
              },
            ],
          },
          {
            path: 'conf',
            name: 'setting',
            component: () =>
              import(/* webpackChunkName: "conf" */ '../views/setting'),
            meta: {},
            redirect: '/adm/conf/dashboard',
            children: [
              {
                path: 'dashboard',
                name: 'dashboardSetting',
                meta: {
                  modulName: 'setting',
                  pageName: 'dashboardSetting',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-dashboard" */ '../views/setting/dashboard'
                  ),
              },
              {
                path: 'users',
                name: 'users',
                meta: {
                  modulName: 'setting',
                  pageName: 'userSystem',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-users" */ '../views/setting/users'
                  ),
              },
              {
                path: 'user-akses',
                name: 'userAkses',
                meta: {
                  modulName: 'setting',
                  pageName: 'userAkses',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-userakses" */ '../views/setting/user-akses'
                  ),
              },
              {
                path: 'form-user-akses/:id?',
                name: 'formUserAkses',
                meta: {
                  modulName: 'setting',
                  pageName: 'userAkses',
                  pageType: 'create_update',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-userakses" */ '../views/setting/user-akses/form-user-akses'
                  ),
              },
              {
                path: 'container-type',
                name: 'containerType',
                meta: {
                  modulName: 'setting',
                  pageName: 'containerType',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-container-type" */ '../views/setting/container-type'
                  ),
              },
              {
                path: 'update-container-in',
                name: 'updateContainerIn',
                meta: {
                  modulName: 'setting',
                  pageName: 'updateContainerIn',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-cont-in" */ '../views/setting/update-cont-in'
                  ),
              },
              {
                path: 'change-container-no',
                name: 'changeContNo',
                meta: {
                  modulName: 'setting',
                  pageName: 'changeContNo',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-change-cont-no" */ '../views/setting/change-cont-number'
                  ),
              },
              {
                path: 'exchange-do',
                name: 'exchangeDO',
                meta: {
                  modulName: 'setting',
                  pageName: 'exchangeDO',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-exchange-do" */ '../views/setting/exchange-do'
                  ),
              },
              {
                path: 'pindah-stock',
                name: 'pindahStock',
                meta: {
                  modulName: 'setting',
                  pageName: 'pindahStock',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-pindah-stock" */ '../views/setting/pindah-stock-container'
                  ),
              },
              {
                path: 'form-pindah-stock',
                name: 'formPindahStock',
                meta: {
                  modulName: 'setting',
                  pageName: 'pindahStock',
                  pageType: 'create_update',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-pindah-stock" */ '../views/setting/pindah-stock-container/form-pindah-stock'
                  ),
              },
              {
                path: 'principle-price',
                name: 'custPrice',
                meta: {
                  modulName: 'setting',
                  pageName: 'principlePrice',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-principle-price" */ '../views/setting/principle-price'
                  ),
              },
              {
                path: 'form-principle-price/:id?',
                name: 'custPriceForm',
                meta: {
                  modulName: 'setting',
                  pageName: 'principlePrice',
                  pageType: 'create_update',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-principle-price" */ '../views/setting/principle-price/form'
                  ),
              },
              {
                path: 'block-container',
                name: 'blockContainer',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "conf-block-container" */ '../views/setting/block-container'
                  ),
                redirect: '/conf/block-container/container',
                children: [
                  {
                    path: 'container',
                    name: 'blockContainerContainer',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "conf-block-cont-cont" */ '../views/setting/block-container/container'
                      ),
                  },
                  {
                    path: 'interchange',
                    name: 'blockContainerInterchange',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "conf-block-cont-inter" */ '../views/setting/block-container/interchange'
                      ),
                  },
                  {
                    path: 'booking',
                    name: 'blockContainerBooking',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "conf-block-cont-book" */ '../views/setting/block-container/booking'
                      ),
                  },
                ],
              },
              {
                path: 'tools',
                name: 'tools',
                meta: {},
                component: () =>
                  import(
                    /* webpackChunkName: "conf-tools" */ '../views/setting/tools'
                  ),
                redirect: '/conf/tools/back-stock',
                children: [
                  {
                    path: 'back-stock',
                    name: 'toolsBackStock',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "conf-back-stock" */ '../views/setting/tools/back-stock'
                      ),
                  },
                  {
                    path: 'one-way',
                    name: 'toolsOneWay',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "conf-one-way" */ '../views/setting/tools/one-way'
                      ),
                  },
                  {
                    path: 'admin-tools',
                    name: 'toolsAdminTools',
                    meta: {},
                    component: () =>
                      import(
                        /* webpackChunkName: "conf-admin-tools" */ '../views/setting/tools/admin-tools'
                      ),
                  },
                ],
              },
              {
                path: 'rekening-bank/:id_company?',
                name: 'rekeningBank',
                meta: {
                  modulName: 'setting',
                  pageName: 'rekeningBank',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-rekening-bank" */ '../views/setting/company-info/rekening-bank'
                  ),
              },
              {
                path: 'company-info',
                name: 'companyInfo',
                meta: {
                  modulName: 'setting',
                  pageName: 'companyInfo',
                  pageType: 'view',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-company-info" */ '../views/setting/company-info'
                  ),
              },
              {
                path: 'form-company/:id?',
                name: 'formCompany',
                meta: {
                  modulName: 'setting',
                  pageName: 'companyInfo',
                  pageType: 'create_update',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-form-company" */ '../views/setting/company-info/form-company'
                  ),
              },
              {
                path: 'akun-jenis-pembayaran',
                name: 'akunJenisPembayaran',
                meta: {
                  modulName: 'setting',
                  pageName: 'akunJenisPembayaran',
                  pageType: 'create_update',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-akun-jenis-bayar" */ '../views/setting/akun-jenis-bayar'
                  ),
              },
              {
                path: 'signature',
                name: 'settingSignature',
                meta: {
                  modulName: 'setting',
                  pageName: 'settingSignature',
                  pageType: 'create_update',
                },
                component: () =>
                  import(
                    /* webpackChunkName: "conf-signature" */ '../views/setting/signature'
                  ),
              },
            ],
          },
          {
            path: 'login',
            name: 'login',
            component: () =>
              import(/* webpackChunkName: "login" */ '../views/account/login'),
            meta: {},
          },
          {
            path: 'forgot-password',
            name: 'ForgotPassword',
            component: () =>
              import(
                /* webpackChunkName: "forgot" */ '../views/account/forgot-password'
              ),
            meta: {},
          },
          {
            path: 'profile',
            name: 'ProfileAdmin',
            component: () =>
              import(
                /* webpackChunkName: "profile-admin" */ '../views/account/profile'
              ),
            meta: {},
          },
        ],
      },
      {
        path: '/usr',
        name: 'user',
        meta: {},
        component: () =>
          import(/* webpackChunkName: "user" */ '../views/layouts/user'),
        redirect: '/',
        children: [
          {
            path: 'dashboard',
            name: 'userDashboard',
            meta: {},
            component: () =>
              import(
                /* webpackChunkName: "user-dashboard" */ '../views/user/user-dashboard'
              ),
            children: [],
          },
          {
            path: 'eir-in',
            name: 'userEirIn',
            meta: {},
            component: () =>
              import(
                /* webpackChunkName: "user-eir-in" */ '../views/user/user-eir-in'
              ),
            children: [],
          },
          {
            path: 'print-eir-in/:id?',
            name: 'usrEirPrintEirIn',
            meta: {
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-eirin" */ '../views/user/user-eir-in/print'
              ),
          },
          {
            path: 'eir-out',
            name: 'userEirOut',
            meta: {},
            component: () =>
              import(
                /* webpackChunkName: "user-eir-out" */ '../views/user/user-eir-out'
              ),
            children: [],
          },
          {
            path: 'print-eir-out/:id?',
            name: 'usrPrintEirContainerOut',
            meta: {
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-eir-out-printform" */ '../views/user/user-eir-out/print'
              ),
          },
          {
            path: 'form-estimate-cost/:id?',
            name: 'usrFormDamageCost',
            meta: {},
            component: () =>
              import(
                /* webpackChunkName: "opr-form-estimate-cost" */ '../views/user/user-eor/form-estimate'
              ),
          },
          {
            path: 'eor',
            name: 'userEor',
            meta: {},
            component: () =>
              import(
                /* webpackChunkName: "user-eor" */ '../views/user/user-eor'
              ),
            children: [],
          },
          {
            path: 'pti',
            name: 'userPTI',
            meta: {},
            component: () =>
              import(
                /* webpackChunkName: "user-pti" */ '../views/user/user-pti'
              ),
            children: [],
          },
          {
            path: 'form-estimatepti-cost/:id?',
            name: 'usrPtiFormEstimateCost',
            meta: {},
            component: () =>
              import(
                /* webpackChunkName: "opr-pti-form-estimate-cost" */ '../views/user/user-pti/form-estimate'
              ),
          },
          {
            path: 'invoice',
            name: 'userInvoice',
            meta: {},
            component: () =>
              import(
                /* webpackChunkName: "user-invoice" */ '../views/user/user-invoice'
              ),
            children: [],
          },
          {
            path: 'print-invoice/:id',
            name: 'userPrintInvoice',
            meta: {
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "user-print-invoice" */ '../views/user/user-invoice/print-tagihan'
              ),
            children: [],
          },
          {
            path: 'profile',
            name: 'userProfile',
            component: () =>
              import(
                /* webpackChunkName: "user-profile" */ '../views/user/user-profile'
              ),
            children: [],
          },
        ],
      },
    ],
  },
  {
    path: '/print-page',
    name: 'printPage',
    meta: {},
    component: () =>
      import(
        /* webpackChunkName: "print-page" */ '../views/layouts/print-page'
      ),
  },
  {
    path: '/print-eir-in/:typecetak?/:searchdata?',
    name: 'printEirInUser',
    meta: {
      printReport: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "print-eirin-user" */ '../views/layouts/print-eir-in'
      ),
  },
  {
    path: '/print-eir-out/:typecetak?/:searchdata?',
    name: 'printEirOutUser',
    meta: {
      printReport: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "print-eirout-user" */ '../views/layouts/print-eir-out'
      ),
  },
  {
    path: '*',
    name: 'NotFound',
    component: () =>
      import(/* webpackChunkName: "forgot" */ '../views/layouts/notfound'),
  },
];
